/* eslint-disable no-lonely-if */
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { getCookie, removeAllCookies } from '@/utils/storage';
import { PREFIX } from '@/config/constants';
import store from '@/store';
import router from '@/router';
NProgress.configure({
  showSpinner: false
});
const whiteList = ['/login'];
router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start();
  const hasToken = getCookie(PREFIX.ACCESS_TOKEN);
  next();
  NProgress.done();
  if (hasToken) {
    if (to.path === '/login') {
      next({
        path: '/'
      });
      NProgress.done();
    }
  } else {
    removeAllCookies();
    store.commit('user/RESET_STATE');
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      NProgress.done();
    }
  }
});
router.afterEach(() => {
  NProgress.done();
});